
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M237 38.6c-8.4 1.8-13.7 3.7-23.5 8.8-17.3 8.9-30.7 22.7-39.5 41-5.9 12.1-7.8 19.2-8.7 30.8l-.6 8.8H144c-11.3 0-23.3.5-26.6 1.1-13.3 2.4-27.7 12.2-35.5 24.2-7.2 11.1-7.1 10.1-17.4 114.5-5.2 53-9.5 98.9-9.5 102.1 0 14.3 6.1 35.6 14.1 49.7 14.7 25.7 38.4 44 67.5 52.1l9.9 2.8h219l9.8-2.7c39.5-11.1 69.2-41.6 78.7-80.9 4.1-16.9 4-18.8-5.9-118.4-5.1-50.6-9.8-95.6-10.6-99.9-3.4-19.1-16.3-34.2-35.3-41.4-6.4-2.5-7.9-2.6-30.8-3l-24.1-.4-.6-8.6c-.9-11.6-2.9-18.7-8.7-30.8-12.5-25.9-35.7-44.2-63.2-49.8-9.5-2-28.8-2-37.8 0m30.3 35.9c23 4.8 40.4 24.1 43.2 47.7l.7 5.8H200.8l.7-5.8c2.2-18.6 13.8-35.2 30.2-43.2 11.8-5.7 23.2-7.2 35.6-4.5M192.5 204c5.3 3.3 7.6 8 8.6 17.4 1.6 15.9 7 27.7 17.5 37.9 5.8 5.6 17.9 12 26.1 13.7 8.3 1.8 22.4.8 29.8-2 21.1-8 34-25.5 36.4-49.6.9-9.4 3.3-14.1 8.5-17.4 8-4.9 18.5-3 24.2 4.6 2.6 3.3 2.9 4.7 3.3 12 .9 22.3-10.1 48-27.7 64.6-8.7 8.2-14 11.8-24.4 16.8-13.3 6.4-22 8.3-38.3 8.3-16.3.1-25.5-1.9-39.4-8.4-31.6-14.7-53.3-48.8-52-81.3.4-7.3.7-8.7 3.3-12 5.7-7.5 16.2-9.5 24.1-4.6"}})])
          )
        }
      }
    